import axios from 'axios';
import getSettings from './get-settings';

export default function make() {
  if (localStorage.getItem('settings') === null) {
    return null;
  }

  const settings = getSettings();

  return axios.create({
    baseURL: settings.url,
    timeout: 10000,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'totem': settings.token,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
    },
    withCredentials: false
  });

}

export function hal_http() {
  return axios.create({
    baseURL: 'http://localhost:5000',
    timeout: 10000,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
    },
    withCredentials: false
  });
}
